import _ from 'lodash';

import Config from '@skin_config';

// Bet builder legs share a `bet_builder_match_id` on the swarm bet record.
// All legs of one card collapse to ONE effective selection so the wheel
// eligibility check matches the convention used everywhere else in the
// betslip (bet-type resolution, banker validation, wheelConfig.usageRules).
// A single BB card with N legs reads as 1 here, NOT N.
const getEffectiveSelectionCount = (selectionList) => {
  if (!selectionList?.length) return 0;
  const bbCardIds = new Set();
  let regular = 0;
  selectionList.forEach((item) => {
    if (item.bet_builder_match_id != null) bbCardIds.add(item.bet_builder_match_id);
    else regular += 1;
  });
  return regular + bbCardIds.size;
};

export const hasProfitBoost = (bet, stakeAmount) => {
  const minSelectionOddPasses = (
      !Config.wheelConfig?.minSelectionOdd
      || bet.selection_list.every((item) => item.price > Config.wheelConfig.minSelectionOdd)
  );

  const effectiveCount = getEffectiveSelectionCount(bet.selection_list);

  return (
    Config.wheelConfig.enableWheel &&
    effectiveCount >= Config.wheelConfig.minSelectionsCount
    && minSelectionOddPasses
    && _.inRange(stakeAmount, Config.wheelConfig.minStake, Config.wheelConfig.maxStake || 100000000000000000)
    && _.inRange(bet.price, Config.wheelConfig.minOdd, Config.wheelConfig.maxOdd || 100000000000000000)
  );
}
